import * as tslib_1 from "tslib";
import { OnInit, EventEmitter } from '@angular/core';
import { IsInvalidDirective } from 'src/app/modules/core/directives/is-invalid.directive';
import { NgForm } from '@angular/forms';
export class VideosRowComponent {
    constructor(userService) {
        this.userService = userService;
        this.wasSubmitted = false;
        this.editing = false;
        this.video = {};
        this.original = {};
        this.onSave = new EventEmitter();
        this.onEditing = new EventEmitter();
        this.onDelete = new EventEmitter();
    }
    get showEditing() {
        return this.editing || !this.isEditVideo;
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.getCurrentUser();
            this.original = this.video;
            this.video = Object.assign({}, this.video);
        });
    }
    save() {
        if (this.isInvalidDirectives.some(value => value.isInvalid)) {
            this.wasSubmitted = true;
            return;
        }
        this.onSave.emit(this.video);
        this.video = {};
        this.markClean();
    }
    saveEdit() {
        if (this.isInvalidDirectives.some(value => value.isInvalid)) {
            this.wasSubmitted = true;
            return;
        }
        this.editing = false;
        this.original = Object.assign({}, this.video);
        this.onEditing.emit(this.video);
        this.markClean();
    }
    openEdit() {
        this.editing = true;
        this.original = this.video;
        this.video = Object.assign({}, this.video);
    }
    revert() {
        this.editing = false;
        this.video = this.original;
        this.markClean();
    }
    delete() {
        this.onDelete.emit(this.video);
    }
    markClean() {
        this.original = {};
        this.form.control.markAsPristine();
        this.form.control.markAsUntouched();
        this.wasSubmitted = false;
    }
    getCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentUser = yield this.userService.getCurrentUserAsync();
        });
    }
}
